var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentLogo05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.717 0v42.01h-3.733L4.164 6.83h-.328v35.18H0V0h3.713l24.902 35.22h.328V0h3.774zm11.169 42.01V0h24.37v3.446H47.721v15.815h19.24v3.446h-19.24v15.856h20.943v3.447H43.886zm34.297 0V0h24.307v3.446H82.019v15.815h18.564v3.446H82.019V42.01h-3.836zm31.302-38.564V0h30.461v3.446h-13.312V42.01h-3.836V3.446h-13.313z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLogo05);
export default __webpack_public_path__ + "static/media/payment-logo05.145923a115909d0d1d38d467825c4714.svg";
export { ForwardRef as ReactComponent };